import React from "react";
import { useState } from "react";
import Loader from "../common/loader";
import Select, { components } from 'react-select';
import { useRef } from "react";
import { CSVLink } from "react-csv";
import InputField from "../common/Input";
import { CbiRoleOptions } from "./constant";
import { isEmpty } from "../../config/helper";
import { MasterService } from "../../services";
import { useEffect } from "react";
import ReactPaginate from "react-paginate";
import { debounce } from "../../utils";
import { DEBOUNCE_DELAY_IN_MS } from "../../config/constant";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const { ValueContainer, Placeholder } = components;

const CbiDashboard = () => {
    const csvLink = useRef();
    const navigate = useNavigate();
    const prevRoleId = useRef(CbiRoleOptions[0].value);
    const [loading, setLoading] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const [userList, setUserList] = useState([]);
    const [allCount, setAllCount] = useState(0);
    const [filter, setFilter] = useState({ page: 0, limit: 10, role_id: CbiRoleOptions[0].value });
    const [pagination, setPagination] = useState({ total: 0 });

    const debouncedGetUserList = useRef(
       debounce((newFilter) => {
         setFilter(newFilter);
       }, DEBOUNCE_DELAY_IN_MS)
    ).current;
    
      useEffect(() => {
        return () => {
          debouncedGetUserList.cancel();
        };
      }, [debouncedGetUserList]);

    useEffect(() => {
        fetchCbiUserList(filter);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter]);

    const fetchCbiUserList = async(filter) => {
        setLoading(true);
        let response = await MasterService.post('/sfa/user/get_cbi_users_list', { ...filter, page: filter.page + 1,vertical_id:1});
        if(response.status === 200){
            let { data, pagination } = response.data;
            setUserList(data);
            setPagination(pagination);
            if(!allCount && pagination?.total) setAllCount(pagination.total);
            if(filter.role_id !== prevRoleId.current){
                setAllCount(pagination?.total);
                prevRoleId.current = filter.role_id;
            }
        }
        setLoading(false);
             
    }

    const handleInputChange = (e) => {
        let newFilter = { ...filter, search: e.target.value, page: 0 };
        debouncedGetUserList(newFilter);
    }
    
    const handleSelectChange = (selectedOption) => {
        prevRoleId.current = filter.role_id;
        setFilter(prev => ({ ...prev, role_id: selectedOption.value, page: 0 }));
    }

    const exclusiveFilters = ['cbi_form_generated', 'document_uploaded'];
    
    const handleFilterChange = (name) => {
        setFilter(prev => {
            const cleanedFilter = Object.keys(prev)
                .filter(key => !exclusiveFilters.includes(key))
                .reduce((acc, key) => {
                    acc[key] = prev[key];
                    return acc;
                }, {});

            if (name === 'all') return cleanedFilter;

            return { ...cleanedFilter, page: 0, [name]: 1 };
        });
    };

    const handleViewUser = (user) => {
        navigate(`/view-user/${user.user_id}`);
    }

     const handleExport = async() => {
        if(isEmpty(userList)){
            toast.error("No data available for export");
            return;
        }
        setLoading(true);
        let response = await MasterService.post('/sfa/user/export_cbi_users_list', filter);
        setLoading(false);
        if(response.status === 200){
            let { data } = response.data;
            if(isEmpty(data)){
                toast.error("No data available for export");
                return;
            }
            setCsvData(data);
            csvLink.current.link.click();
            toast.success("Exported successfully");
        }else{
            toast.error("Failed to export data");
        }
    }

    const handlePageClick = (e) => {
        const selectedPage = e.selected;
        setFilter(prev => ({ ...prev, page: selectedPage }));
    };
    let pageCount = pagination?.total && pagination?.limit ? Math.ceil(pagination?.total / pagination?.limit) : 0;

    return (
        <>
        {loading ? <Loader /> : null}
             <div className="cbi-dashboard-container">  
                <div className="top-heading d-flex"> <h1>CBI Dashboard</h1> </div>
                <div className="cbi-filter-bg">
                   <fieldset className="single-select col-md-4">
                    <div className="material">
                        <Select
                            components={{ ValueContainer: CustomValueContainer }}
                            options={CbiRoleOptions}
                            value={CbiRoleOptions.find(option => option.value === filter.role_id)}
                            onChange={handleSelectChange}
                            placeholder="Select User Profile"
                            className="react-select"
                            classNamePrefix="react-select"
                        />
                    </div>
                </fieldset>

                  <div>
                    <button onClick={handleExport} className="btn-primary">
                        <i class="ic-export m-xs-r"></i>
                        <span>Export Data</span>
                    </button>
                    <CSVLink data={csvData} filename={`user-list-${Math.round(+new Date() / 1000)}.csv`} data-interception='off' ref={csvLink}></CSVLink>
                  </div>
                </div>

                <div className="top-heading d-flex"> <h1>Users List</h1> </div>

                <div className="cbi-table-container">
                    <div className="cbi-table-filter-container">
                        <fieldset className="search-bx">
                            <div class="material">
                                <InputField
                                id="search_by"
                                type="text"
                                placeholder="Search By SFA ID, Name"
                                name="search"
                                autoComplete="off"
                                label="Search"
                                onChange={handleInputChange}
                                value={filter?.search || ''}
                                />
                                <i className="ic-search"></i>
                            </div>
                        </fieldset>
                        <button className={`btn-filter ${isEmpty(filter?.cbi_form_generated || filter?.document_uploaded) ? 'btn-filter-active' : ''}`} onClick={()=>handleFilterChange('all')}>
                            All({allCount || 0})
                        </button>
                        <button className={`btn-filter ${filter?.cbi_form_generated ? 'btn-filter-active' : ''}`} onClick={()=>handleFilterChange('cbi_form_generated')}>
                            CBI Form Generated
                        </button>
                          <button className={`btn-filter ${filter?.document_uploaded ? 'btn-filter-active' : ''}`} onClick={()=>handleFilterChange('document_uploaded')}>
                            Credit Document Uploaded
                        </button>
                    </div>
            
                </div>
                <div  className="cbi-userlist-table data-table">
                <table>
                     <thead>
                        <tr>
                            <th>Name & ID</th>  
                            <th>CBI Form Generated</th>  
                            <th>CBI Form Generation Date</th>  
                            <th>Credit Score Document Upload</th>  
                            <th>Document Upload Date</th>  
                            <th>Credit Score</th>  
                            <th>Collectibility<br></br>(Past Loan)</th>  
                            <th>Collectibility<br></br>(Current Loan)</th>  
                            <th>PD</th>  
                            <th>Action</th>  
                        </tr>
                     </thead>
                     <tbody>
                        {
                            userList.map((user, index) => (
                                <tr key={index}>
                                    <td>{user.name} ({user.user_id})</td>
                                    <td>{user.cbi_form_generated ?? "-"}</td>
                                    <td>{user.cbi_form_generation_date ?? "-"}</td>
                                    <td>{user.credit_score_document_upload ?? "-"}</td>
                                    <td>{user.document_upload_date ?? "-"}</td>
                                    <td>{user.credit_score ?? "-"}</td>
                                    <td>{user.past_loan_type_label ?? "-"}</td>
                                    <td>{user.current_loan_type_label ?? "-"}</td>
                                    <td>{user.default_probability ?? "-"}</td>
                                    <td> <i onClick={()=>handleViewUser(user)} className="ic-remove_red_eyevisibility"></i></td>
                                </tr>
                            ))  
                        }
                        
                     </tbody>
                </table>   
                <div className='pagination-bx' id="dealerUserList">
                    <ReactPaginate
                        previousLabel={"<"}
                        nextLabel={">"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        forcePage={filter.page}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"} />
                </div >        

                </div>

             </div>
        </>
    );
};

export default CbiDashboard;

 const CustomValueContainer = ({ children, ...props }) => {
        return (
            <ValueContainer {...props}>
                <Placeholder {...props} isFocused={props.isFocused}>
                    {props.selectProps.placeholder}
                </Placeholder>
                {React.Children.map(children, child =>
                    child && child.type !== Placeholder ? child : null
                )}
            </ValueContainer>
        );
    };